import { useEffect } from "react";
import { X } from "lucide-react";

/** Click-to-zoom lightbox for avatars/photos. */
export default function ImageLightbox({ src, alt, open, onClose }) {
  useEffect(() => {
    if (!open) return;
    const onKey = (e) => {
      if (e.key === "Escape") onClose?.();
    };
    document.addEventListener("keydown", onKey);
    // lock scroll while open
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = prev;
    };
  }, [open, onClose]);

  if (!open || !src) return null;

  return (
    <div
      data-testid="image-lightbox"
      className="fixed inset-0 z-[100] flex items-center justify-center"
    >
      <button
        className="absolute inset-0 bg-black/90 backdrop-blur-sm"
        onClick={onClose}
        aria-label="Close"
        data-testid="lightbox-backdrop"
      />
      <button
        onClick={onClose}
        data-testid="lightbox-close-btn"
        className="absolute top-5 right-5 z-10 h-10 w-10 bg-black/60 backdrop-blur-md border border-white/15 hover:border-[#FF007F] text-white hover:text-[#FF007F] flex items-center justify-center transition-colors"
      >
        <X className="h-5 w-5" />
      </button>
      <div className="relative max-w-[90vw] max-h-[90vh] animate-[fadeIn_180ms_ease-out]">
        <img
          src={src}
          alt={alt || ""}
          className="block max-w-[90vw] max-h-[90vh] object-contain border-2 border-[#39FF14]/40 shadow-[0_0_60px_rgba(57,255,20,0.25)]"
          onClick={(e) => e.stopPropagation()}
          data-testid="lightbox-image"
        />
      </div>
      <style>{`
        @keyframes fadeIn {
          from { opacity: 0; transform: scale(0.96); }
          to { opacity: 1; transform: scale(1); }
        }
      `}</style>
    </div>
  );
}
